<h1 i18n="@@upp.markets.display.title">Display Market</h1>

<ama-upp-notification
  [mainMessages]="mainMessages"
  [notification]="(notification$ | async)!"
  (closeNotificationEvent)="closeNotification()"
>
</ama-upp-notification>

<ama-ng-upp-markets-details
  [marketDetailsForm]="marketForm"
  [marketDetails]="marketDetails"
  [readonly]="readonly"
  [parent]="uppComponent"
>
</ama-ng-upp-markets-details>

<div class="d-flex justify-content-end">
  <button
    i18n="@@upp.markets.button.copy"
    type="button"
    class="btn btn-outline-primary mb-2 mb-md-0 me-2"
    (click)="copyMarket()"
    [disabled]="!hasManageAccess()"
  >
    Copy
  </button>

  <button
    i18n="@@upp.global.button.modify"
    type="button"
    [disabled]="!modifyButtonEnabled()"
    class="btn btn-primary mb-2 mb-md-0 me-2"
    (click)="modifyMarket()"
  >
    Modify
  </button>
</div>
